// src/mixins/enterpriseStationMixin.js
import { pub } from '/common/event';

export default {
  data() {
    return {
      enterpriseList: [],
      stationOptions: [],
    };
  },
  computed: {
    _scopeForm() {
      return this.searchForm || this.form || {};
    },
  },
  methods: {
    async loadEnterpriseList() {
      try {
        const ret = await this.$api.enterprise.page({ status: 1, current: 1, pageSize: 999 });
        if (ret && ret.success) {
          this.enterpriseList = ret.data?.data || ret.data || [];
        }
      } catch (e) {
        pub('error_message', '加载企业列表失败');
      }
    },
    async loadStationList(enterpriseId) {
      const form = this._scopeForm;
      if (!enterpriseId) {
        this.stationOptions = [];
        if (form) form.stationId = null;
        return;
      }
      try {
        const ret = await this.$api.station.getOptions(enterpriseId);
        if (ret && ret.success) {
          this.stationOptions = ret.data || ret.data?.data || [];
        } else {
          this.stationOptions = [];
        }
        if (form.stationId && !this.stationOptions.some((s) => String(s.id) === String(form.stationId))) {
          form.stationId = null;
        }
      } catch (e) {
        console.error('[enterpriseStationMixin] 加载站点列表异常:', e);
        this.stationOptions = [];
        pub('error_message', '加载站点列表失败');
      }
    },
    handleEnterpriseChange(val) {
      const form = this._scopeForm;
      if (form) form.stationId = null;
      this.loadStationList(val);
    },
  },
  mounted() {
    this.loadEnterpriseList?.();
  },
};